import { Component } from "@angular/core";

import { PlantsBrandingComponent } from "../branding/plants-branding.component";
import { PlantsPrimaryNavComponent } from "../primary-nav/plants-primary-nav.component";

@Component({
  selector: "plants-header",
  imports: [PlantsBrandingComponent, PlantsPrimaryNavComponent],
  templateUrl: "./plants-header.component.html",
  styleUrls: ["./plants-header.component.scss"]
})
export class PlantsHeaderComponent {}
